import moment from "moment";
import React, { useEffect, useState } from "react";
import { useLoad } from "../../context";
import ApiServices from "../../services/apiServices";
import Mask from "../../services/mask";
import storage from "../../services/storage";
import "./index.css";

export default function MeusDados() {
  const { load, setLoad } = useLoad();
  const [user] = useState(storage.get("USUARIO")?.loginResponse);
  const [eu, setEu] = useState({
    nome: "",
    cpfCnpj: "",
    email: "",
    codiCli: "",
    phoneNumber: "",
    dataNascimento: "",
    cep1: "",
    logradouro1: "",
    numero1: "",
    complemento1: "",
    bairro1: "",
    uf1Aux: "",
    cidade1Aux: "",
    mesmoEnderecoEntrega: true,
  });

  async function fnEu() {
    try {
      setLoad(true);
      let response = await ApiServices.apiGet("eu");

      setEu(response.data);
      setEu((prevState) => ({
        ...prevState,
        dataNascimento: moment(response.data.dataNascimento).format(
          "DD/MM/YYYY"
        ),
      }));
    } catch (err) {
      console.error("err", err);
    } finally {
      setLoad(false);
    }
  }

  useEffect(() => {
    fnEu();
  }, []); //eslint-disable-line react-hooks/exhaustive-deps

  // Função para obter iniciais do nome
  const getIniciais = (nome) => {
    if (!nome) return "U";
    const partes = nome.split(" ");
    if (partes.length >= 2) {
      return (partes[0][0] + partes[partes.length - 1][0]).toUpperCase();
    }
    return nome.substring(0, 2).toUpperCase();
  };

  return (
    <>
      <div className="d-flex justify-content-center meusDadosContainer">
        <div className="container mx-5 px-5">
          {/* <div className="row mt-5">
            <h2 className="text-center mb-4">Meu cadastro</h2>
          </div> */}

          {/* Avatar */}
          {/* <div className="d-flex justify-content-center mb-5">
            <div className="avatarCircle">
              {getIniciais(eu?.nome || user?.profile?.nome)}
            </div>
          </div> */}

          {/* Dados Pessoais */}
          <div className="row mb-5">
            <h3 className="mb-4">Dados pessoais</h3>
            <div className="row">
              <div className="col-md-4 mb-3 campo-busca">
                <label className="form-label">ID cliente</label>
                <input
                  type="text"
                  className="form-control"
                  value={eu?.codiCli || ""}
                  disabled
                />
              </div>
              <div className="col-md-4 mb-3 campo-busca">
                <label className="form-label">Nome</label>
                <input
                  type="text"
                  className="form-control"
                  value={eu?.nome || ""}
                  disabled
                />
              </div>
              <div className="col-md-4 mb-3 campo-busca">
                <label className="form-label">CPF</label>
                <input
                  type="text"
                  className="form-control"
                  value={Mask.cpfCnpj(eu?.cpfCnpj) || ""}
                  disabled
                />
              </div>
            </div>

            <div className="row">
              <div className="col-md-4 mb-3 campo-busca">
                <label className="form-label">Data nascimento</label>
                <input
                  type="text"
                  className="form-control"
                  value={eu?.dataNascimento || ""}
                  disabled
                />
              </div>
              <div className="col-md-4 mb-3 campo-busca">
                <label className="form-label">Celular</label>
                <input
                  type="text"
                  className="form-control"
                  value={Mask.cel(eu?.phoneNumber) || ""}
                  disabled
                />
              </div>
              <div className="col-md-4 mb-3 campo-busca">
                <label className="form-label">E-mail</label>
                <input
                  type="text"
                  className="form-control"
                  value={eu?.email || ""}
                  disabled
                />
              </div>
            </div>
          </div>

          {/* Endereço Cadastrado */}
          <div className="row mb-5">
            <h3 className="mb-4">Endereço cadastrado</h3>
            <div className="row">
              <div className="col-md-4 mb-3 campo-busca">
                <label className="form-label">CEP</label>
                <input
                  type="text"
                  className="form-control"
                  value={Mask.cep(eu?.cep1) || ""}
                  disabled
                />
              </div>
              <div className="col-md-4 mb-3 campo-busca">
                <label className="form-label">Logradouro</label>
                <input
                  type="text"
                  className="form-control"
                  value={eu?.logradouro1 || ""}
                  disabled
                />
              </div>
              <div className="col-md-4 mb-3 campo-busca">
                <label className="form-label">Número</label>
                <input
                  type="text"
                  className="form-control"
                  value={eu?.numero1 || ""}
                  disabled
                />
              </div>
            </div>

            <div className="row">
              <div className="col-md-4 mb-3 campo-busca">
                <label className="form-label">Complemento</label>
                <input
                  type="text"
                  className="form-control"
                  value={eu?.complemento1 || ""}
                  disabled
                />
              </div>
              <div className="col-md-4 mb-3 campo-busca">
                <label className="form-label">Bairro</label>
                <input
                  type="text"
                  className="form-control"
                  value={eu?.bairro1 || ""}
                  disabled
                />
              </div>
              <div className="col-md-4 mb-3 campo-busca">
                <label className="form-label">Cidade</label>
                <select
                  className="form-select"
                  value={eu?.cidade1Aux || ""}
                  disabled
                >
                  <option value="">Selecione</option>
                  <option value={eu?.cidade1Aux}>{eu?.cidade1Aux}</option>
                </select>
              </div>
            </div>

            <div className="row">
              <div className="col-md-4 mb-3 campo-busca">
                <label className="form-label">Estado</label>
                <select
                  className="form-select"
                  value={eu?.uf1Aux || ""}
                  disabled
                >
                  <option value="">Selecione</option>
                  <option value={eu?.uf1Aux}>{eu?.uf1Aux}</option>
                </select>
              </div>
            </div>
          </div>

          {/* Botão Salvar
          <div className="row d-flex justify-content-center">
            <div className="col-md-3">
              <button className="btn btnSalvar" disabled>
                SALVAR
              </button>
            </div>
          </div> */}
        </div>
      </div>
    </>
  );
}
